import React, { ReactElement } from "react";
import { styled } from "@sourceful/shared-components";
import Flickity from "react-flickity-component";
import "flickity/dist/flickity.min.css";

const Wrapper = styled("div", {
  display: "flex",
  gap: "$block_s2",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  alignSelf: "start",
  height: "fit-content",
  width: "100%",
  maxWidth: "600px",
  ".main-image-carousel": {
    width: "100%",
    aspectRatio: "1 / 1",

    figure: {
      margin: "0",

      "&:not(:first-child)": {
        display: "none",
      },
    },
  },
  ".flickity-enabled": {
    figure: {
      display: "block !important",
    },
  },
  variants: {
    isSticky: {
      true: {
        "@lg": {
          position: "sticky",
          top: 0,
        },
      },
    },
  },
});

interface RenderProps {
  registerControlCarousel: (c: Flickity) => void;
  registerMainCarousel: (c: Flickity) => void;
  handleSelect: (index: number) => void;
  selectedIndex: number | undefined;
  isReady: boolean;
  mainCarouselEvents?: FlickityCarouselEvents;
  controlCarouselEvents?: FlickityCarouselEvents;
}

export interface FlickityCarouselEvents {
  onReady?: () => void;
  onChange?: (index: number) => void;
}

interface GalleryWrapperProps {
  isSticky?: boolean;
  wrapperClassName?: string;
  render: (props: RenderProps) => ReactElement;
}

interface GalleryWrapperState {
  isReady: boolean;
}

class GalleryWrapper extends React.Component<GalleryWrapperProps, GalleryWrapperState> {
  flktyMainCarousel?: Flickity;
  flktyControlCarousel?: Flickity;

  state: GalleryWrapperState = { isReady: false };

  registerControlCarousel = (c: Flickity) => {
    return (this.flktyControlCarousel = c);
  };

  registerMainCarousel = (c: Flickity) => {
    return (this.flktyMainCarousel = c);
  };

  handleSelect = (index: number) => {
    this.flktyControlCarousel?.select(index, false, false);
  };

  render() {
    const { wrapperClassName, isSticky, render } = this.props;

    const selectedIndex = this.flktyControlCarousel?.selectedIndex;
    const { isReady } = this.state;

    return (
      <Wrapper className={wrapperClassName} isSticky={isSticky}>
        {render({
          registerControlCarousel: this.registerControlCarousel,
          registerMainCarousel: this.registerMainCarousel,
          handleSelect: this.handleSelect,
          selectedIndex,
          isReady,
          mainCarouselEvents: {
            onReady: () => {
              this.setState({ isReady: true });
            },
            onChange: (index: number) => {
              this.flktyControlCarousel?.select(index, false, false);
            },
          },
          controlCarouselEvents: {
            onChange: (index: number) => {
              this.flktyMainCarousel?.select(index, false, true);
              this.forceUpdate();
            },
          },
        })}
      </Wrapper>
    );
  }
}

export default GalleryWrapper;
